export default __webpack_public_path__ + "static/media/defaultGalleryItem.7d005d22.svg";